import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PalletOverridesPage } from './pallet-overrides.page';
import { TermSelectPageModule } from '../term-select/term-select.module';

const routes: Routes = [
  {
    path: '',
    component: PalletOverridesPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TermSelectPageModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PalletOverridesPage]
})
export class PalletOverridesPageModule {}
